import React, { useState } from "react";

import { get } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import NextPreviousFooter from "shared/components/NextPreviousFooter";
import Product from "shared/components/Product";
import RadioGroup from "shared/components/RadioGroup";
import Space from "shared/components/Space";
import Spin from "shared/components/Spin";
import { StepStore } from "shared/components/Tab";
import { NAME_SPACES } from "shared/locals/constants";

import FoldersTitle from "../Common/FoldersTitle";
import { BREAKDOWN } from "../constants";
import "./styles.scss";

const Intervention = ({
  query: { data, loading },
  product,
  setActiveStep,
  warranty,
  step: { changeTab, onBack },
  onChange,
}) => {
  const { t } = useTranslation(NAME_SPACES.NEW_FOLDER, {
    keyPrefix: "INTERVENTION",
  });
  const rules = get(data, "rules.data.interventionTypes", []);
  const [intervention, setIntervention] = useState();

  return (
    <>
      <div className={"newfolder--wrapper--content"}>
        <FoldersTitle title={t("TITLE")} subTitle={t("SUB_TITLE")} />
        <div className={"newfolder--wrapper--content--search"}>
          <div className="warranty">
            {loading ? (
              <Spin />
            ) : (
              <>
                <p>{warranty}</p>
              </>
            )}
          </div>
          <div className={"newfolder--wrapper--content--search--result"}>
            <Product
              type={"listOptions"}
              items={[product]}
              options={
                <RadioGroup
                  loading={loading}
                  values={rules.map(({ code, desc }) => ({
                    label: desc,
                    value: code,
                  }))}
                  onChange={(_code) =>
                    setIntervention(rules.find(({ code }) => code === _code))
                  }
                />
              }
            />
            <Space h={32} />
          </div>
        </div>
      </div>
      <NextPreviousFooter
        onPreviousClick={() => {
          setActiveStep(1);
          onBack();
        }}
        nextEnabled={!!intervention}
        previousEnabled={true}
        onNextClick={() => {
          onChange({ intervention });
          changeTab(BREAKDOWN);
          setActiveStep(3);
        }}
      />
    </>
  );
};

Intervention.propTypes = {
  product: PropTypes.object.isRequired,
  query: PropTypes.shape({
    data: PropTypes.shape({
      rules: PropTypes.shape({
        data: PropTypes.shape({
          interventionTypes: PropTypes.array,
        }),
        count: PropTypes.number,
      }),
    }),
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  setActiveStep: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  warranty: PropTypes.string.isRequired,
  step: PropTypes.shape({
    changeTab: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  }).isRequired,
};

Intervention.defaultProps = {};

export default StepStore(Intervention);
